import Big from "big.js";

export interface ShopperShippingFeeLines {
  /** Shown as "Return shipping". */
  returnShipping: number;
  /** Shown as "Carrier upgrade", beside and like "Return shipping". */
  carrierUpgrade: number;
}

/**
 * Splits part of the shopper-owed shipping fee into display lines, pro rata.
 * The upgrade folds into return shipping unless Redo covers the label.
 */
export function getShopperShippingFeeLines({
  amount,
  shopperShippingFee,
  carrierUpgradeFee,
  isLabelCovered,
}: {
  /** The part of the fee this line shows, such as the deducted part. */
  amount: number;
  /** The whole shopper-owed shipping fee, label plus upgrade. */
  shopperShippingFee: number;
  carrierUpgradeFee: number;
  isLabelCovered: boolean;
}): ShopperShippingFeeLines {
  if (
    !isLabelCovered ||
    amount <= 0 ||
    carrierUpgradeFee <= 0 ||
    shopperShippingFee <= 0
  ) {
    return { returnShipping: amount, carrierUpgrade: 0 };
  }
  const carrierUpgrade = Big(amount)
    .times(Math.min(carrierUpgradeFee, shopperShippingFee))
    .div(shopperShippingFee)
    .round(2)
    .toNumber();
  return {
    returnShipping: Big(amount).minus(carrierUpgrade).toNumber(),
    carrierUpgrade,
  };
}
